// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"c611772c","212":"ab076edc","316":"cbdc9a22","511":"904e27ee","592":"524b7959","746":"1af2f0fa"}[chunkId] + ".chunk.js";
};